import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }


  recoveryPassword(dataIn) {

    let url = ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.USERS.RECOVERY_PASSWORD;

    return this.http.post(url, dataIn);

  }

  sendOneTimePassword(dataIn) {

    let url = ENV.BASE_PATH.USERS + CONSTANTS.END_POINTS.USERS.SEND_ONE_TIME_PASSWORD;

    return this.http.post(url, dataIn);

  }



}
